import {Component, OnInit} from '@angular/core';
import {UserService,ScrollService} from '../../../api/';
import {User} from '../../../../models/';
import {Router, ActivatedRoute} from '@angular/router';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

@Component({
    selector: 'app-lifestyle',
    templateUrl: './lifestyle.component.html',
    styleUrls: ['./lifestyle.component.css']
})
export class LifestyleComponent implements OnInit {
    public model: User;
    private educations: Array<any> = [];
    private incomes: Array<any> = [];
    verified: boolean = false;

    @BlockUI() blockUI: NgBlockUI;
    public onlineOffline1: boolean = navigator.onLine;

    constructor(private scrollService:ScrollService,private userService: UserService, private router: Router, private route: ActivatedRoute) {
        window.addEventListener('online', () => {this.onlineOffline1 = true; });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});

        this.model = new User();
        this.blockUI.start('Loading, please wait...');
        this.getEducation();
        this.getIncome();
        this.model.has_children = '0';
    }

    submitLifestyle() {
        if(this.onlineOffline1) {            
            this.userService.saveLifestyle(this.model).subscribe((res) => {
                this.router.navigate(['/notification-setting'], {queryParams: {verified: this.verified}});
            }, (err) => {
            });
        }
        this.blockUI.start('Loading, please wait...');
    }

    getUserProfileData() {
        if(this.onlineOffline1) {
            this.userService.getUserProfileData().subscribe((res) => {                
                this.model.optional_education_id = res.profile.optional_education_id;
                this.model.optional_income_id = res.profile.optional_income_id;
                this.model.marital_status = res.profile.marital_status;
                this.model.has_children = res.profile.has_children;
                const status = localStorage.getItem('status');
                // to check if other steps are already filled
                if(status > res.profile.status) {
                    this.model.status = status;
                } else {
                    this.model.status = res.profile.status;
                }
                // when filling the form for first time and response is empty
                if(!res.profile.optional_education_id) {
                    this.model.optional_education_id = '14';
                }                
                if(!res.profile.optional_income_id) {
                    this.model.optional_income_id = '1';
                }
                if(!res.profile.marital_status) {
                    this.model.marital_status = 'S';
                }
                if(!res.profile.has_children) {
                    this.model.has_children = '0';
                }
                localStorage.setItem('status', this.model.status);
                this.blockUI.stop(); // Stop blocking
            }, (err) => {
            });
        }else {
            this.blockUI.stop(); // Stop blocking
        }
    }

    getEducation() {
        if(this.onlineOffline1){
        this.userService.getEducation().subscribe((res) => {
            this.educations = res;            
        }, (err) => {
        });
        }
    }

    getIncome() {
     if(this.onlineOffline1){
        this.userService.getIncome().subscribe((res) => {
            this.incomes = res;
        }, (err) => {
        });
     }
    }

    ngOnInit() {
        this.scrollService.enableScrollIfDisabled();
    }

    ngAfterViewInit() {
        this.verified = this.route.snapshot.queryParams['verified'];
        setTimeout(() => {
            this.getUserProfileData();
        }, 1000);

    }

}



// WEBPACK FOOTER //
// ./src/app/user/signup/lifestyle/lifestyle.component.ts